"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_environment__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "152b9169-3f5f-4bc7-8c73-44040d05ecb1",
    x1: 103.91,
    y1: 80.75,
    x2: 139.82,
    y2: 116.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#666",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#666",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cce61c9f-c873-4008-bdae-d36550fbaf83",
    "data-name": "Environment_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8,166.3a4,4,0,0,1-3.37-6.15,371.59,371.59,0,0,1,93.15-99.87,4,4,0,0,1,4.75,6.44,363.59,363.59,0,0,0-91.15,97.72A4,4,0,0,1,34.8,166.3Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33,64.73a363.6,363.6,0,0,0-91.15,97.72,4,4,0,0,1-7.23-1.13,4,4,0,0,0,7.23,3.13,363.6,363.6,0,0,1,91.15-97.72,4,4,0,0,0,1.49-4.24A4,4,0,0,1,129.33,64.73Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.05,142.41l-1.73,0A89.86,89.86,0,0,1,53,139.15a4,4,0,0,1-2.81-2.88A89.61,89.61,0,0,1,161.11,28.19a4,4,0,0,1,2.81,2.88A89.63,89.63,0,0,1,77.05,142.41Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,133.53a89.81,89.81,0,0,1-2.49-19.65,89.85,89.85,0,0,0,2.15,20.17",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.57,54.56a89.82,89.82,0,0,0-2.65-23.48,4,4,0,0,0-.17-.51c-18,16.54-40.19,34.48-58.42,49.77-19,15.92-38.27,40-54.26,57.58A4,4,0,0,0,53,139.15a89.86,89.86,0,0,0,22.31,3.24l1.73,0A89.66,89.66,0,0,0,166.57,54.56Z",
    fill: "url(#152b9169-3f5f-4bc7-8c73-44040d05ecb1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.35,139.76a95.09,95.09,0,0,0,20,2.63l1.73,0a89.66,89.66,0,0,0,89.51-87.85q0-1.57,0-3.13c0,.38,0,.75,0,1.13a89.66,89.66,0,0,1-89.51,87.85l-1.73,0a90.07,90.07,0,0,1-18.67-2.31,26.09,26.09,0,0,1-4.37-1.58l-1.19,1.44S51.82,138.93,55.35,139.76Z",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("title", null, "environment-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "24134a7f-f8a6-4f4d-83aa-10af61f0b11d",
    "data-name": "Environment_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "018c5607-67b9-44b8-af2b-4f43a179039e",
    "data-name": "Environment_ic_hi",
    width: 192,
    height: 192,
    xlinkHref: "#cce61c9f-c873-4008-bdae-d36550fbaf83"
  })));
}

var _default = ic_environment__dark;
exports.default = _default;